import { middlewareController } from '../middlewareController'

const BASE_URL = process.env.REACT_APP_CONTAINER_V2_API_ENDPOINT

export const containerApi = middlewareController.create.axiosInstance({
  baseURL: BASE_URL
})

export * from './requests'
